import { Typography } from '@release/ui/Typography';
import { ReactNode } from 'react';

interface LabelProps {
  label?: ReactNode;
  helperText?: ReactNode;
  required?: boolean;
  className?: string;
}

export const Label: React.FC<LabelProps> = ({ label, required, helperText, className }) => {
  if (!label) {
    return null;
  }

  const renderLabel = (
    <label className="flex w-full items-center gap-x-1">
      <Typography size="rabbit" weight="bold" className="w-fit">
        {label}
      </Typography>
      {required && (
        <div className="flex h-4 items-center rounded bg-prim-cranberry-40 px-0.5">
          <Typography className="break-keep text-ant leading-none text-sem-d-text-high">必須</Typography>
        </div>
      )}
    </label>
  );

  const renderHelperText = helperText && (
    <Typography size="ant" className="text-sem-l-text-medium">
      {helperText}
    </Typography>
  );

  return (
    <div className={`flex shrink-0 flex-col ${className || ''}`}>
      {renderLabel}
      {renderHelperText}
    </div>
  );
};
